"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsTablet = void 0;
var _mui = require("@ori-ui/mui");
const useIsTablet = () => (0, _mui.useMediaQuery)(theme => theme.breakpoints.down('md'));
exports.useIsTablet = useIsTablet;
